import { useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router'
import { isEmpty, sortBy } from 'lodash'

import Loader from 'components/Loader'
import OrdersMobile from 'components/Orders/List/OrdersMobile'
import OrdersDesktop from 'components/Orders/List/OrdersDesktop'
import OrdersPagination from 'components/Orders/Pagination'

import { getAllOrders, getIsAllOrdersLoading } from 'store/Orders/selector'

const Orders = () => {
  const history = useHistory()
  const { uuid: orderUuid } = useParams()

  const allOrders = useSelector(getAllOrders)
  const isLoadingAllOrders = useSelector(getIsAllOrdersLoading)

  const isModal = !isEmpty(orderUuid)
  const isLoading = isLoadingAllOrders && !isModal

  const sortedOrders = sortBy(allOrders, 'name')

  const onClickItem = (uuid) => () => {
    history.push(`orders/${uuid}`)
  }

  if (isLoading) {
    return <Loader />
  } else {
    return (
      <>
        <OrdersMobile orders={sortedOrders} onClickItem={onClickItem} />
        <OrdersDesktop orders={sortedOrders} onClickItem={onClickItem} />
        <OrdersPagination />
      </>
    )
  }
}

export default Orders
